import React from 'react';
import Skeleton from "@material-ui/lab/Skeleton";

const SkeletonPanl = () => {
  return (
    <div>
              <Skeleton width="60%" style={{ marginBottom: 40 , marginTop: 10 ,  marginLeft: 90 , marginRight: 90 ,  width:'auto' , borderRadius:13,}}  />
                  <Skeleton variant="rect" width={210} height={130} style={{ marginBottom: 70 ,  width:'auto', marginLeft: 50 , marginRight: 50 , borderRadius:15,  }}  />

                  
    </div>
  );
};


export default SkeletonPanl;